<template>

    <div>
        <h1 class="text-4xl my-24 text-center font-headings">Style Guide</h1>
    </div>

    <div>
        Loading

        <Loading class="w-32 h-32 mx-auto" />
    </div>

    <section class="py-12">
        <div class="max-w-7xl mx-auto">
            <div class="text-2xl font-heaings mb-2 text-gray-800">Colours</div>
            <div class="grid grid-cols-5 gap-4 text-center">

                <div class="grid grid-cols-5">
                    <div class="aspect-square bg-primary-50"></div>
                    <div class="aspect-square bg-primary-100"></div>
                    <div class="aspect-square bg-primary-200"></div>
                    <div class="aspect-square bg-primary-300"></div>
                    <div class="aspect-square bg-primary-400"></div>
                </div>

                <div class="grid grid-cols-5">
                    <div class="aspect-square bg-secondary-50"></div>
                    <div class="aspect-square bg-secondary-100"></div>
                    <div class="aspect-square bg-secondary-200"></div>
                    <div class="aspect-square bg-secondary-300"></div>
                    <div class="aspect-square bg-secondary-400"></div>
                </div>

                <div class="grid grid-cols-5">
                    <div class="aspect-square bg-accent-50"></div>
                    <div class="aspect-square bg-accent-100"></div>
                    <div class="aspect-square bg-accent-200"></div>
                    <div class="aspect-square bg-accent-300"></div>
                    <div class="aspect-square bg-accent-400"></div>
                </div>


                <div class="">
                </div>

                <div class="">

                </div>

                <div
                    class="rounded-xl aspect-video bg-primary-500 flex items-center justify-center text-white text-2xl font-bold">
                    Primary<br />#4f39f6</div>
                <div
                    class="rounded-xl aspect-video bg-secondary-500 flex items-center justify-center text-white text-2xl font-bold">
                    Secondary<br />#805af5</div>
                <div
                    class="rounded-xl aspect-video bg-accent-500 flex items-center justify-center text-white text-2xl font-bold">
                    Accent<br />#ff69b2</div>
                <div style="background-color: #f5f5f5; color: #1e1e1e;"
                    class="rounded-xl aspect-video flex items-center justify-center text-white text-2xl font-bold">
                    Neutral<br />#6b7280
                </div>
                <div style="background-color: #101828;"
                    class="rounded-xl aspect-video bg-dark-500 flex items-center justify-center text-white text-2xl font-bold">
                    Dark<br />#101828
                </div>

                <div class="grid grid-cols-4">
                    <div class="aspect-square bg-primary-600"></div>
                    <div class="aspect-square bg-primary-700"></div>
                    <div class="aspect-square bg-primary-800"></div>
                    <div class="aspect-square bg-primary-900"></div>                    
                </div>

                <div class="grid grid-cols-4">
                    <div class="aspect-square bg-secondary-400"></div>
                    <div class="aspect-square bg-secondary-700"></div>
                    <div class="aspect-square bg-secondary-800"></div>
                    <div class="aspect-square bg-secondary-900"></div>
                </div>

                <div class="grid grid-cols-4">
                    <div class="aspect-square bg-accent-400"></div>
                    <div class="aspect-square bg-accent-700"></div>
                    <div class="aspect-square bg-accent-800"></div>
                    <div class="aspect-square bg-accent-900"></div>
                </div>


                <div class="">
                </div>

                <div class="">

                </div>
            </div>
        </div>
    </section>

    <section class="py-12">
        <div class="max-w-7xl mx-auto">
            <div class="text-2xl font-headings mb-2 text-gray-800">Logo</div>
            <div class="grid grid-cols-2 gap-4">
                <div style="background-color: #f5f5f5;"
                    class="rounded-xl aspect-video flex items-center justify-center text-white text-2xl font-bold">
                    <img class="object-contain w-2/3" :src="entegyLogo" alt="Entegy Logo" />
                </div>
                <div
                    class="rounded-xl aspect-video bg-primary-500 flex items-center justify-center text-white text-2xl font-bold">
                    <img class="object-contain w-2/3" :src="entegyLogoWhite" alt="Entegy Logo" />
                </div>
                <div style="background-color: #f5f5f5;"
                    class="rounded-xl aspect-video flex items-center justify-center text-white text-2xl font-bold">
                    <div class="h-64 w-2/3 logo-mask entegy-gradient" :style="{ maskImage: `url(${entegyLogoWhite})` }" alt="Entegy Logo"></div>
                </div>
                <div style="background-color: #f5f5f5;"
                    class="rounded-xl aspect-video flex items-center justify-center text-white text-2xl font-bold">
                    <div class="h-64 w-2/3 logo-mask" :style="{ maskImage: `url(${entegyLogoWhite})`, backgroundColor: '#101828' }" alt="Entegy Logo"></div>
                </div>
            </div>

        </div>
    </section>

    <section class="py-12">
        <div class="max-w-7xl mx-auto">
            <div class="text-2xl font-headings mb-2 text-gray-800">Typeface</div>

            <div class="flex">
                <div class="w-1/4">
                    Headings
                </div>

                <div class="w-3/4 text-gray-800">
                    <div class="text-7xl font-headings">Nunito SemiBold</div>
                    <div class="mt-4 text-4xl font-headings">The Quick Brown Fox Jumps Over The Lazy Dog</div>

                </div>
            </div>

            <div class="flex mt-12 hidden">
                <div class="w-1/4">
                    Headings
                </div>

                <div class="w-3/4 text-gray-800">
                    <div class="text-7xl font-inter">Inter SemiBold</div>
                    <div class="mt-4 text-4xl font-inter">The Quick Brown Fox Jumps Over The Lazy Dog</div>

                </div>
            </div>

            <div class="flex mt-12">
                <div class="w-1/4">
                    Body
                </div>

                <div class="w-3/4 text-gray-800">
                    <div class="text-5xl">Inter</div>
                    <div class="mt-4 text-2xl">The Quick Brown Fox Jumps Over The Lazy Dog</div>
                </div>
            </div>

            <div class="flex mt-12 hidden">
                <div class="w-1/4">
                    Body
                </div>

                <div class="w-3/4 text-gray-800 font-roboto">
                    <div class="text-5xl">Roboto Sans</div>
                    <div class="mt-4 text-2xl">The Quick Brown Fox Jumps Over The Lazy Dog</div>
                </div>
            </div>

        </div>

    </section>

    <section class="py-12">
        <div class="max-w-7xl mx-auto">
            <div class="text-2xl font-headings mb-2 text-gray-800">Gradients</div>
            <div class="grid grid-cols-2 gap-4">
                <div
                    class="rounded-xl aspect-video entegy-gradient flex items-center justify-center text-white text-2xl font-bold">
                </div>
                <div
                    class="rounded-xl aspect-video entegy-gradient-light flex items-center justify-center text-white text-2xl font-bold">
                </div>
            </div>
        </div>
    </section>

    <section class="py-12">
        <div class="max-w-7xl mx-auto">
            <div class="text-2xl font-headings mb-2 text-gray-800">Shapes</div>
            <div class="grid grid-cols-6 gap-4">
                <div v-for="index in 10" :key="index" class="aspect-square bg-primary-500"
                    :class="`entegy-shape-${index}`"></div>
            </div>
        </div>
    </section>

    <section class="py-12">
        <div class="max-w-7xl mx-auto">
            <div class="text-2xl font-headings mb-2 text-gray-800">Patterns</div>

            <PatternNew :columns="10" :rows="4" variant="default" :isAnimated="true" />

            <div class="rounded-xl entegy-gradient mt-12">
                <PatternNew :columns="5" :rows="3" variant="transparent" :isAnimated="true" />
            </div>

            <div class="rounded-xl bg-linear-to-r from-primary-500 to-primary-600 mt-12">
                <PatternNew :columns="10" :rows="5" variant="outline" outlineClass="border-secondary-500" :isAnimated="true" />
            </div>

            <div class="rounded-xl bg-linear-to-br from-secondary-400 to-secondary-500 mt-12">
                <PatternNew :columns="20" :rows="10" variant="transparent" :isAnimated="true" />
            </div>
        </div>
    </section>

    <section class="py-12">
        <div class="max-w-7xl mx-auto">
            <div class="text-2xl font-headings mb-2 text-gray-800">Icons</div>
            <div class="grid grid-cols-12 gap-4">
                <div v-for="icon in icons" :key="icon.name">
                    <div
                        class="w-12 h-12 shadow-md bg-linear-to-tr from-secondary-500 to-primary-500 border-primary-500 text-white p-2 pill-icon transition-all duration-300">
                        <component :is="icon.icon" class="w-8 h-8" />
                    </div>
                </div>
            </div>
            <div class="grid grid-cols-12 gap-4 mt-12">
                <div v-for="icon in icons" :key="icon.name">
                    <div
                        class="w-12 h-12 shadow-md border-2 border-secondary-500 text-secondary-500 p-1.5 pill-icon transition-all duration-300">
                        <component :is="icon.icon" class="w-8 h-8" />
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section class="py-12">
        <div class="max-w-7xl mx-auto">
            <div class="text-2xl font-headings mb-2 text-gray-800">Accent Images</div>
            <div class="grid grid-cols-4 gap-4">
                <div class="bg-gray-900 p-10">
                    <img src="https://labs.entegy.com.au/entegy/rocket.svg" alt="Accent Image 1"
                        class="w-full h-full object-contain">
                </div>
                <div class="bg-gray-100 p-10">
                    <img src="https://www.entegy.events/images/contact-us.svg" alt="Accent Image 1"
                        class="w-full h-full object-contain">
                </div>
                <div class="bg-gray-100 p-10">
                    <img :src="megaphone" alt="Accent Image 1" class="w-full h-full object-contain">
                </div>
                <div class="bg-gray-100 p-10">
                    <img :src="australia" alt="Accent Image 1" class="w-full h-full object-contain">
                </div>
            </div>
        </div>
    </section>

    <section class="py-12">
        <div class="max-w-7xl mx-auto">
            <div class="text-2xl font-headings mb-2 text-gray-800">Photography</div>
            <img :src="photography" alt="Photography" class="w-full h-full object-cover">
        </div>
    </section>


</template>

<script setup>
import Loading from '../components/Loading.vue';
import PatternNew from '../components/PatternNew.vue';
import entegyLogo from '@/images/entegy-logo.svg';
import entegyLogoWhite from '@/images/entegy-logo-white.svg';
import megaphone from '@/images/megaphone.svg';
import australia from '@/images/australia.svg';
import photography from '@/images/photography.png';
import {
    CreditCardIcon,
    GlobeAltIcon,
    PhoneIcon,
    UserGroupIcon,
    EnvelopeIcon,
    VideoCameraIcon,
    ClipboardDocumentIcon,
    Bars3Icon,
    QrCodeIcon,
    MapIcon,
    MicrophoneIcon,
    BuildingOfficeIcon,
    Squares2X2Icon,
    CodeBracketIcon,
    BuildingOffice2Icon,
    ShieldCheckIcon,
    MagnifyingGlassIcon,
    UserPlusIcon,
    AcademicCapIcon,
    BriefcaseIcon
} from '@heroicons/vue/24/outline'


const icons = [
    {
        name: 'Registration & Tickets',
        description: 'Streamlined registration and ticketing',
        icon: CreditCardIcon
    },
    {
        name: 'Websites Builder',
        description: 'Custom event websites made easy',
        icon: GlobeAltIcon
    },
    {
        name: 'Event Apps',
        description: 'Native mobile event applications',
        icon: PhoneIcon,
        link: '/features/eventapp'
    },
    {
        name: 'Audience Participation',
        description: 'Engage attendees with interactive tools',
        icon: UserGroupIcon
    },
    {
        name: 'Emails & Communications',
        description: 'Send targeted communications',
        icon: EnvelopeIcon
    },
    {
        name: 'Meetings & Networking',
        description: 'Facilitate connections and meetings',
        icon: VideoCameraIcon
    },
    {
        name: 'Lead Capture',
        description: 'Capture and manage leads efficiently',
        icon: ClipboardDocumentIcon,
        link: '/features/leadcapture'
    },
    {
        name: 'Attendance Tracking',
        description: 'Track attendance and engagement',
        icon: Bars3Icon
    },
    {
        name: 'Badges & Kiosks',
        description: 'Print badges and manage check-ins',
        icon: QrCodeIcon
    },
    {
        name: 'Interactive Floorplans',
        description: 'Navigate and explore event spaces',
        icon: MapIcon
    },
    {
        name: 'Speaker Portals',
        description: 'Dedicated speaker management',
        icon: MicrophoneIcon
    },
    {
        name: 'Exhibitor Portals',
        description: 'Comprehensive exhibitor tools',
        icon: BuildingOfficeIcon
    }
]
</script>

<style>
.logo-mask {
    mask-position: center;
    mask-repeat: no-repeat;
}

.entegy-gradient {
    background:
        linear-gradient(217deg, #4f39f6, transparent 70.71%),
        linear-gradient(127deg, #7d38ff, transparent 70.71%),
        linear-gradient(336deg, #ff69b2, transparent 70.71%);
}

.entegy-gradient-light {
    background: linear-gradient(50deg, white 25%, #e0dbff)
}

.animated-gradient {
    animation: gradientShift 10s ease infinite;
    background-size: 200% 200%;
}

@keyframes gradientShift {
    0% {
        background-position: 0% 50%;
    }

    50% {
        background-position: 100% 50%;
    }

    100% {
        background-position: 0% 50%;
    }
}


.entegy-shape-1 {
    border-top-right-radius: 75%;
}

.entegy-shape-2 {
    border-top-left-radius: 75%;
}

.entegy-shape-3 {
    border-bottom-right-radius: 75%;
}

.entegy-shape-4 {
    border-bottom-left-radius: 75%;
}

.entegy-shape-5 {
    border-radius: 0%;
}

.entegy-shape-6 {
    border-radius: 100%;
}

.entegy-shape-7 {
    border-radius: 35%;
}

.entegy-shape-8 {
    border-bottom-left-radius: 35%;
    border-bottom-right-radius: 35%;
    border-top-left-radius: 35%;
}

.entegy-shape-9 {
    border-bottom-left-radius: 35%;
    border-bottom-right-radius: 35%;
    border-top-right-radius: 35%;
}

.entegy-shape-10 {
    mask-image: url('/src/images/sparkle.svg');
    mask-repeat: no-repeat;
    mask-position: center;
    mask-size: 100% 100%;
    animation: scaleIn 0.5s ease-out;
}

@keyframes scaleIn {
    from {
        transform: scale(0);
        opacity: 0;
    }

    to {
        transform: scale(1);
        opacity: 1;
    }
}
</style>
